import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { endOfDay } from "../shared/utils/trial.util";
import { OnboardingSessionData } from "./onboarding.interface";

@Injectable({
  providedIn: "root",
})
export class OnboardingService {
  constructor(private http: HttpClient) {}

  createDomainOnboarding = (domain: string, request: OnboardingSessionData) =>
    this.http.post<{ success: boolean }>(
      `/onboarding/${encodeURIComponent(domain)}/create`,
      {
        ...request,
        isIncludedDemoContent: request.isIncludedDemoContent ?? false,
        trialFinishDate: request.trialFinishDate
          ? endOfDay(request.trialFinishDate)
          : undefined,
      },
    );

  enrichWithBrandData = (domain: string) =>
    this.http.post<{ success: boolean }>(
      `/onboarding/${encodeURIComponent(domain)}/enrich-brand`,
      {},
    );

  getCompanyData = (domain: string) =>
    this.http.get<{
      name: string | null;
      address: string | null;
      logoUrl: string | null;
      website: string | null;
    }>(`/onboarding/${encodeURIComponent(domain)}/company-data`);
}
